import { Accepts, Types, OutletType } from "@citychallenge/common";
import { Inlet, Outlet } from "../../reactive";
import { defineElement } from "../define-element";

export class MultipleChoiceProps {
  @Inlet(Accepts.Image) public headerImage?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public introduction?: Types["MarkdownText"];
  @Inlet(Accepts.Text) public question?: Types["Text"];
  @Inlet(Accepts.TextList) public answers?: Types["TextList"];

  @Inlet(Accepts.Number) public correctAnswer!: Types["Number"];

  // Outlets
  @Outlet() public onQuestionCorrect!: OutletType;
  @Outlet() public onQuestionIncorrect!: OutletType;
}

export const MultipleChoiceDefinition = defineElement(
  "multiple-choice",
  MultipleChoiceProps,
  {
    versionRequired: "0.8.0",
  }
);
